// 8.3.7 — learner level control (merged into the locale as `lvl`).
const lvl = {
  "changeLevel": "تغيير المستوى",
  "title": "غيّر مستواك في {lang}",
  "help": "اختر المستوى الذي يناسبك. يمكنك تغييره في أي وقت.",
  "safe": "لن تفقد كلماتك المحفوظة ولا مراجعاتك ولا تقدّمك.",
  "save": "حفظ المستوى",
  "cancel": "إلغاء",
  "saving": "جارٍ الحفظ…",
  "changed": "تم تغيير المستوى إلى {level}. سيتكيّف تدريبك القادم مع مستواك الجديد.",
  "failed": "تعذّر تغيير مستواك. حاول مرة أخرى.",
  "current": "الحالي",
  "profilesHelp": "ملفك اللغوي ومستواه وفق الإطار الأوروبي المرجعي. تغيير المستوى يؤثر في التدريب القادم فقط.",
  "levels": {
    "A1": {
      "name": "مبتدئ",
      "desc": "كلمات أساسية وعبارات يومية بسيطة."
    },
    "A2": {
      "name": "أساسي",
      "desc": "مواقف مألوفة ومحادثات قصيرة."
    },
    "B1": {
      "name": "متوسط",
      "desc": "تتعامل مع المحادثات اليومية باستقلالية متزايدة."
    },
    "B2": {
      "name": "فوق المتوسط",
      "desc": "تناقش موضوعات كثيرة بطبيعية وتفهم لغة أكثر تعقيدًا."
    },
    "C1": {
      "name": "متقدّم",
      "desc": "تعبّر عن أفكارك بطلاقة وتتعامل مع دقائق اللغة."
    },
    "C2": {
      "name": "إتقان عالٍ",
      "desc": "تفهم كل شيء تقريبًا وتعبّر عنه بدقة."
    }
  }
};
export default lvl;
